<template>
    <div>
        <div class="row">
            <div class="col-sm-12">
                <div>
                    <div class="content">
                        <div class="col-sm-12">
                            <h3>{{$t('your_shoppingcart')}}</h3>
                            <div v-if="productsInShoppingCart.length > 0">
                                <div class="row">
                                    <div class="col-sm-12">
                                        <div class="col-sm-offset-6 col-sm-1">
                                            <strong>{{$t('amount')}}</strong>
                                        </div>
                                        <div class="col-sm-1" v-if="loggedInCustomer.showPrices">
                                            <strong>{{$t('price')}}</strong>
                                        </div>
                                        <div class="col-sm-1">
                                            <strong>{{$t('discount')}}</strong>
                                        </div>
                                        <div class="col-sm-1" v-if="loggedInCustomer.showPrices">
                                            <strong>{{$t('total')}}</strong>
                                        </div>
                                    </div>
                                </div>
                                <div v-for="product in sortedProducts">
                                    <div class="row">
                                        <div class="col-sm-12">
                                            <div v-if="product.imageLocation" class="col-sm-1">
                                                <img :src="BACKEND_BASE_URL + '/images/' + product.imageLocation" width="50">
                                            </div>
                                            <div v-if="!product.imageLocation" class="col-sm-1">
                                                <img src="../assets/no-image.svg" width="50">
                                            </div>
                                            <div style="margin-top:15px;">
                                                <div class="col-sm-5">
                                                    <strong>{{ getLocale() == 'nl' ? product.dutchTitle : product.frenchTitle}} ({{product.articleNumber}})</strong>
                                                </div>
                                                <div class="col-sm-1">
                                                    {{Math.abs(product.amount)}}
                                                </div>
                                                <div class="col-sm-1" v-if="loggedInCustomer.showPrices">
                                                    €{{parseFloat(product.price).toFixed(2)}} <span v-if="product.customPrice"><i class="glyphicon glyphicon-info-sign" v-tooltip="'speciale prijs'"></i></span>
                                                </div>
                                                <div class="col-sm-1">
                                                    {{product.discount === '' ? 0 : product.discount}} %
                                                </div>
                                                <div class="col-sm-1" v-if="loggedInCustomer.showPrices">
                                                    €{{parseFloat(Math.abs(product.amount) * product.price * (1 - product.discount / 100 )).toFixed(2)}}
                                                </div>
                                                <div class="col-sm-2">
                                                    <i class="glyphicon glyphicon-remove pull-right" @click="removeProductFromShoppingCart(product)"></i>
                                                    <i class="glyphicon glyphicon-edit pull-right" @click="showProduct(product)"></i>
                                                </div>
                                            </div>
                                        </div>
                                        <hr class="col-sm-12">
                                    </div>
                                </div>
                                <div class="row" v-if="loggedInCustomer.showPrices">
                                    <div class="col-sm-12">
                                        <div class="col-sm-offset-7 col-sm-2">
                                            <strong>{{$t('total_netto')}}</strong>
                                        </div>
                                        <div class="col-sm-2">
                                            €{{parseFloat(totalAmountToPay).toFixed(2)}}
                                        </div>
                                    </div>
                                </div>
                                <div class="row" style="margin-top: 20px;">
                                    <div class="col-sm-12">
                                        <label>{{$t('remark_information')}}:</label>
                                        <textarea class="form-control"
                                                  rows="8"
                                                  :placeholder="$t('remark_information_placeholder')"
                                                  v-model="newOrder.remark"
                                                  style="resize: none"></textarea>
                                    </div>
                                </div>
                                <div class="row" style="margin-top: 10px;">
                                    <div class="col-sm-12">
                                        <div class="col-sm-4" style="padding: 0">
                                            <label>{{$t('reference')}}:</label>
                                            <input type="text" class="form-control" v-model="newOrder.reference">
                                        </div>
                                        <div class="pull-right" style="margin-top: 20px;">
                                            <button type="button" class="btn btn-danger" @click="createQuote()">{{$t('place_quote')}}</button>
                                            <button type="button" class="btn btn-success" @click="createOrder()">{{$t('place_order')}}</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="productsInShoppingCart.length === 0">
                                {{$t('no_products_in_shoppingcart')}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <bt-footer />
    </div>
</template>

<script>
    import BtFooter from './BTFooter.vue'
    import { mapGetters } from 'vuex'
    import * as types from '../store/mutation-types'

    export default {
        name: 'ShoppingCart',
        data() {
            return {
                BACKEND_BASE_URL: process.env.VUE_APP_BACKEND_BASE_URL,
                newOrder: { remark: '', reference: '' }
            }
        },
        created() {
            document.title = 'Brabant-Tools | Winkelwagen'
            if (this.loggedInCustomer.id) {
                this.$store.dispatch('getDiscounts').then(() => {
                    if (this.discounts) {
                        this.$store.commit(types.ADD_DISCOUNTS_TO_PRODUCTS_IN_SHOPPINGCART, this.discounts)
                        this.$store.dispatch('getPricesForCustomerOnAuth').then(() => {
                            if (this.customerSpecificPrices) {
                                this.$store.commit(types.ADD_CUSTOMER_SPECIFIC_PRICES_TO_PRODUCTS_IN_SHOPPINGCART, this.customerSpecificPrices)
                            }
                        })
                        this.$store.dispatch('saveShoppingCart', this.loggedInCustomer.id)
                    } else {
                        this.$store.commit(types.ADD_DISCOUNTS_TO_PRODUCTS_IN_SHOPPINGCART, [])
                    }
                })
            } else {
                if (window.sessionStorage.getItem('customer')) {
                    this.$store.dispatch('getDiscounts').then(() => {
                        if (this.discounts) {
                            this.$store.commit(types.ADD_DISCOUNTS_TO_PRODUCTS_IN_SHOPPINGCART, this.discounts)
                            this.$store.dispatch('getPricesForCustomerOnAuth').then(() => {
                                if (this.customerSpecificPrices) {
                                    this.$store.commit(types.ADD_CUSTOMER_SPECIFIC_PRICES_TO_PRODUCTS_IN_SHOPPINGCART, this.customerSpecificPrices)
                                }
                            })
                            this.$store.dispatch('saveShoppingCart')
                        }
                    })
                } else {
                    this.$store.commit(types.ADD_DISCOUNTS_TO_PRODUCTS_IN_SHOPPINGCART, [])
                    this.$store.dispatch('saveShoppingCart')
                }
            }
        },
        methods: {
            getLocale() {
                return this.$i18n.locale
            },
            showProduct(product) {
                this.$modal.show('show-product-modal', { productId: product.id, amount: product.amount, discount: product.discount })
            },
            removeProductFromShoppingCart(product) {
                this.$store.commit(types.REMOVE_PRODUCT_FROM_SHOPPING_CART, product)
                this.$store.dispatch('saveShoppingCart', this.loggedInCustomer.id)
            },
            createOrder() {
                if (this.loggedInCustomer.id) {
                    this.newOrder.customerId = this.loggedInCustomer.id
                    this.$store.commit(types.SET_ORDER_TO_CREATE, { order: this.newOrder, products: this.productsInShoppingCart })
                    this.$store.dispatch('createOrder').then(() => {
                        if (this.isOrderCreated) {
                            this.$store.dispatch('sendOrderConfirmationMail', this.order.id).then(() => {
                                if (this.isOrderMailSent) {
                                    this.$notify({ group: 'success', type: 'success', title: 'Bedankt voor uw bestelling!', text: 'Een bevestigingsmail is verzonden naar ' + this.loggedInCustomer.email + '!' })
                                    this.$store.commit(types.SET_PRODUCTS_IN_SHOPPING_CART, [])
                                    this.$store.dispatch('saveShoppingCart', this.loggedInCustomer.id)
                                    this.$router.push('/')
                                } else {
                                    this.$notify({ group: 'danger', type: 'error', title: 'Error', text: 'Er is iets fout gegaan bij de bestelling1!' })
                                }
                            })
                        } else {
                            this.$notify({ group: 'danger', type: 'error', title: 'Error', text: 'Er is iets fout gegaan bij de bestelling2!' })
                        }
                    })
                } else {
                    this.$modal.show('no-customer-yet-modal', { order: this.newOrder, products: this.productsInShoppingCart })
                }
            },
            createQuote() {
                if (this.loggedInCustomer.id) {
                    this.newOrder.customerId = this.loggedInCustomer.id
                    this.$store.dispatch('sendQuoteConfirmationMail', { order: this.newOrder, products: this.productsInShoppingCart, admin: this.isAdmin }).then(() => {
                        if (this.isQuoteMailSent) {
                            this.$notify({ group: 'success', type: 'success', title: 'Bedankt voor uw offerte!', text: 'Een bevestigingsmail is verzonden naar ' + this.loggedInCustomer.email + '!' })
                            this.$router.push('/')
                        } else {
                            this.$notify({ group: 'danger', type: 'error', title: 'Error', text: 'Er is iets fout gegaan bij de offerte!' })
                        }
                    })
                } else {
                    this.$modal.show('no-customer-yet-modal')
                }
            },
        },
        components: {
            BtFooter
        },
        computed: {
            ...mapGetters({
                productsInShoppingCart: 'productsInShoppingCart',
                discounts: 'discounts',
                loggedInCustomer: 'loggedInCustomer',
                isOrderCreated: 'isOrderCreated',
                customerSpecificPrices: 'customerSpecificPrices',
                order: 'order',
                isOrderMailSent: 'isOrderMailSent',
                isQuoteMailSent: 'isQuoteMailSent',
                isAdmin: 'isAdmin'
            }),
            totalAmountToPay() {
                let total = 0
                this.productsInShoppingCart.forEach((product) => {
                    total += (parseFloat(Math.abs(product.amount)) * product.price * (1 - product.discount / 100))
                })
                return parseFloat(total).toFixed(2)
            },
            sortedProducts() {
                return this.productsInShoppingCart.sort((a, b) => a.dutchTitle.localeCompare(b.dutchTitle))
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .glyphicon-edit {
        margin-right: 10px;
    }

    .glyphicon {
        cursor: pointer;
    }
</style>
